import { TextInput } from "@dealer-center/core-components";
import { SaveAndCancel } from "@dealer-center/core-custom-components";
import styled from "styled-components";

const StyledInputArea = styled.div`
  padding-bottom: 1rem;
`;

const StyledTextInput = styled(TextInput)`
  margin-bottom: 1rem;
`;

interface PagesAccountHierarchyUiInputProps {
  setName: (name: string) => void;
  nameInput: string;
  setNameInput: (name: string) => void;
  loading: boolean;
}

export const PagesAccountHierarchyUiInput = ({
  nameInput,
  setName,
  setNameInput,
  loading
}: PagesAccountHierarchyUiInputProps) => {
  return (
    <StyledInputArea>
      <StyledTextInput
        label={"Name"}
        name={"PagesAccountHierarchyUiTextInput"}
        placeholder="enter name"
        value={nameInput}
        onChange={e => setNameInput(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") {
            setName(nameInput);
          }
        }}
      />
      <SaveAndCancel
        analyticsEventName="PagesAccountHierarchyUi"
        cancelButtonText="Reset"
        isDisabled={nameInput === ""}
        isSaving={loading}
        saveButtonText="Get Result"
        savingText="Getting Result..."
        onCancel={() => {
          setName("");
          setNameInput("");
        }}
        onSave={() => setName(nameInput)}
      />
    </StyledInputArea>
  );
};
